'use client';

import { PropsWithChildren, useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import { usePageScrollAreaHook } from './hook/usePageScrollAreaHook';

export type PageScrollAreaProps = PropsWithChildren<{
  titulo?: string;
}>;

export default function PageScrollArea(props: PageScrollAreaProps) {
  const caminhoURL = usePathname();
  const [valorMargemTop, setValorMargemTop] = useState(0);
  const { calcularMargemTop } = usePageScrollAreaHook({});

  useEffect(() => {
    setValorMargemTop(calcularMargemTop(caminhoURL));
  }, [caminhoURL, calcularMargemTop]);

  return (
    <div
      id="pageScrollArea"
      style={{
        marginTop: valorMargemTop,
        overflowY: 'auto',
      }}
    >
      {props.children}
    </div>
  );
}
